import { AutoComplete, Button, DatePicker, Form, Input, Popconfirm, Table } from "antd";
import PageContentWrapper from "../../components/PageContentWrapper";
import { useEffect, useState } from "react";
import moment from "moment";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons"; // Import Popconfirm
import { useHistory } from "react-router-dom";
import { getApi, newApi, updateApi } from "../../appRedux/actions/Api";
import { useParams } from "react-router-dom";

export default function NewApiExternalPage() {
  const { apiId } = useParams();
  const history = useHistory();
  const [form] = Form.useForm();
  const [api, setApi] = useState(null);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (apiId) {
      // Fetch API details and set form values
      getApi(apiId).then((data) => {
        const apiData = data?.data;
        setApi(apiData);
        setRoles(JSON.parse(apiData.roles));
        form.setFieldsValue({
          name: apiData.name,
          expired_at: moment(apiData.expired_at),
        });
      });
    }
  }, []);

  const handleCellChange = (key, dataIndex, value) => {
    const newData = [...roles]
    const index = newData.findIndex((item) => key === item.key)
    if (index > -1) {
      const item = newData[index]
      newData.splice(index, 1, { ...item, [dataIndex]: value })
      setRoles(newData)
    }
  }

  const handleDelete = (key) => {
    const newData = roles.filter((item) => item.key !== key);
    setRoles(newData);
  }

  const handleAdd = () => {
    const newData = {
      key: Date.now().toString(),
      path: '',
    }
    setRoles([...roles, newData])
  }

  return (
    <PageContentWrapper
      backLink="/api-external"
      title="Tambah Credential Api External"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={
          api ? {
            ...api,
          } : {
            name: "",
            roles: [],
            expired_at: "",
          }
        }
        style={{ padding: 10 }}
        onFinish={(values) => {
          const payload = {
            ...values,
            expired_at: values.expired_at.format("YYYY-MM-DD HH:mm:ss Z"),
            roles: JSON.stringify(roles),
          }
          if (api) {
            updateApi(apiId, payload).then(() => {
              history.push("/api-external");
            });
          } else {
            newApi(payload).then(() => {
              history.push("/api-external");
            });
          }
        }}
      >
        <Form.Item
          label="Nama Api"
          name="name"
          rules={[{ required: true, message: "Mohon isikan nama api" }]}
        >
          <Input placeholder="API-EXTERNAL" />
        </Form.Item>
        <Form.Item
          label="Expired"
          name="expired_at"
          rules={[{ required: true, message: "Mohon isikan expired" }]}
        >
          <DatePicker
            format="YYYY-MM-DD HH:mm:ss"
            showTime={{
              defaultValue: moment('00:00:00', 'HH:mm:ss'),
            }}
            disabled={apiId ? true : false}
          />
        </Form.Item>
        <Form.Item>
          <Table
            bordered
            dataSource={roles}
            columns={[
              {
                title: 'Path',
                dataIndex: 'path',
                render: (text, record) => (
                  <AutoComplete
                    value={text}
                    options={[
                      { value: '/api/trainings' },
                      { value: '/api/training-options' },
                      { value: '/api/training-registrations' },
                    ]}
                    onChange={(value) => handleCellChange(record.key, 'path', value)}
                    placeholder="Pilih atau ketik Path"
                    style={{ width: '100%' }}
                  />
                ),
              },
              {
                title: 'Read/GET',
                dataIndex: 'GET',
                width: 1,
                align: 'center',
                render: (text, record) => (
                  <Input
                    type="checkbox"
                    checked={text}
                    onChange={(e) => handleCellChange(record.key, 'GET', e.target.checked)}
                  />
                ),
              },
              {
                title: 'Write/POST',
                dataIndex: 'POST',
                width: 1,
                align: 'center',
                render: (text, record) => (
                  <Input
                    type="checkbox"
                    checked={text}
                    onChange={(e) => handleCellChange(record.key, 'POST', e.target.checked)}
                  />
                ),
              },
              {
                title: 'Update/PUT',
                dataIndex: 'PUT',
                width: 1,
                align: 'center',
                render: (text, record) => (
                  <Input
                    type="checkbox"
                    checked={text}
                    onChange={(e) => handleCellChange(record.key, 'PUT', e.target.checked)}
                  />
                ),
              },
              {
                title: 'Delete/DELETE',
                dataIndex: 'DELETE',
                width: 1,
                align: 'center',
                render: (text, record) => (
                  <Input
                    type="checkbox"
                    checked={text}
                    onChange={(e) => handleCellChange(record.key, 'DELETE', e.target.checked)}
                  />
                ),
              },
              {
                title: 'Aksi',
                align: 'center',
                width: 1,
                render: (_, record) => (
                  <Popconfirm title="Apakah yakin akan menghapus baris ini?" onConfirm={() => handleDelete(record.key)}>
                    <Button type="link" danger icon={<DeleteOutlined />} style={{ margin: 0, padding: 0 }} />
                  </Popconfirm>
                ),
              }
            ]}
            pagination={false}
            rowKey="key"
          />

          <div style={{ textAlign: 'center', marginTop: 10 }}>
            <Button onClick={handleAdd} type="dashed" icon={<PlusOutlined />}>
              Tambah End Point
            </Button>
          </div>
        </Form.Item>
        <Form.Item>
          <center>
            <Button type="primary" htmlType="submit">
              Simpan
            </Button>
          </center>
        </Form.Item>
      </Form>
    </PageContentWrapper>
  );
}